import React, { useEffect, useState } from "react";
import axiosInstance from "../HSAxios";
import Cookies from "js-cookie";
import {
  Spinner,
  Card,
  Form,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "react-bootstrap";
import axios from "axios";

const CreateProfile = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("Select ID Type");

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's zero-based
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  const [owner, setOwner] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      axiosInstance.get("api/hostel/owner").then((resposne) => {
        if (resposne.status) {
          console.log(resposne.data[0]);
          setOwner((prev) => ({
            ...prev,
            phone_number: resposne.data[0].phone_number,
          }));

          setLoading(false);
        }
      });
    }
  }, []);
  console.log(owner);
  const handleChange = (key, e) => {
    if (key === "id_proof_type") {
      setOwner(() => ({
        ...owner,
        [key]: e,
      }));
    } else {
      setOwner(() => ({
        ...owner,
        [key]: e.target.value,
      }));
    }
  };
  const handleUpdate = () => {
    console.log("will handle update later");
    // delete owner.phone_number;
    console.log(owner);
    axios
      .post("api/hostel/owner/create", owner)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  console.log(owner);

  return (
    <div>
      {loading && (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
          <Spinner
            animation="border"
            role="status"
            style={{
              width: "3rem",
              height: "3rem",
              borderWidth: "4px",
              borderColor: "#8B0000",
              borderRightColor: "transparent",
            }}
          />
          <p className="mt-4 fw-semibold" style={{ color: "#333", fontSize: "18px" }}>
            Loading your profile...
          </p>
        </div>
      )}

      {!loading && (
        <div>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
            <Card
              className="border-0 shadow-lg"
              style={{
                width: "100%",
                maxWidth: "500px",
                borderRadius: "20px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.1)";
              }}
            >
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <img
                    className="pb-4 rounded-circle img-fluid"
                    src="profileimage.png"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      border: "4px solid #e0e0e0",
                    }}
                    alt="Profile"
                  />
                  <h4 className="fw-bold mt-3" style={{ color: "#760B0B" }}>Create Profile</h4>
                </div>
                <Form className="text-start">
                  <Form.Group className="mt-3">
                    <Form.Label className="fw-semibold mb-2" style={{ color: "#333" }}>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={owner.name || ""}
                      onChange={(e) => handleChange("name", e)}
                      className="py-2"
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0",
                        transition: "border-color 0.3s ease",
                      }}
                      onFocus={(e) => e.target.style.borderColor = "#8B0000"}
                      onBlur={(e) => e.target.style.borderColor = "#e0e0e0"}
                    />
                  </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold"> Email</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("email_id", e)}
                    value={owner.email_id || ""}
                  />
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={owner.phone_number || ""}
                  />
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold"> Address</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("address", e)}
                    value={owner.address || ""}
                  />
                </Form.Group>
                {/* <Form.Group className="mt-3">
                    <Form.Label className="fw-bold"> Date of Birth</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) => handleChange("date_of_birth", e)}
                      value={owner.date_of_birth || ""}
                    />
                  </Form.Group> */}
                <Form.Label className="mt-3 fw-bold">Select Date</Form.Label>
                <Form.Control
                  size="lg"
                  type="date"
                  name="select date"
                  value={owner.date_of_birth || ""}
                  max={formattedDate}
                  id="select date"
                  className="mt-1"
                  onChange={(e) => handleChange("date_of_birth", e)}
                />
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold"> Gender</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("gender", e)}
                    value={owner.gender || ""}
                  />
                </Form.Group>
                <Form.Group className="mt-3">
                  {/* <Form.Label className="fw-bold"> Select ID</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) => handleChange("id_proof_type", e)}
                      value={owner.id_proof_type || ""}
                    /> */}
                  <Form.Group className="mt-3">
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                      <DropdownToggle caret>
                        {owner.id_proof_type || "Select ID Type"}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={(e) =>
                            handleChange("id_proof_type", "AADHAR CARD")
                          }
                        >
                          AADHAR CARD
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            handleChange("id_proof_type", "PAN CARD")
                          }
                        >
                          PAN CARD
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            handleChange("id_proof_type", "LICENSE")
                          }
                        >
                          LICENSE
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </Form.Group>
                  <Form.Label className="fw-bold mt-3">ID Number</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("id_proof_number", e)}
                    value={owner.id_proof_number || ""}
                  />
                </Form.Group>

                <Button
                  style={{
                    backgroundColor: "#004AAD",
                    borderColor: "#004AAD",
                    width: "100%",
                    borderRadius: "10px",
                    padding: "12px",
                    fontSize: "16px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 15px rgba(0, 74, 173, 0.3)",
                  }}
                  className="mt-4 fw-semibold"
                  type="button"
                  onClick={handleUpdate}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#0056b3";
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px rgba(0, 74, 173, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#004AAD";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(0, 74, 173, 0.3)";
                  }}
                >
                  Create Profile
                </Button>
              </Form>
            </Card.Body>
          </Card>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateProfile;
